import axios from "axios";
import querystring from "querystring";

axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.xsrfCookieName = '_csrf';
axios.defaults.xsrfHeaderName = 'X-CSRF-Token';
const token = localStorage.getItem('user-token');
const user = localStorage.getItem('user-id');
if (token && user) {
    axios.defaults.headers.common['X-Authorization'] = 'Bearer ' + token;
    axios.defaults.headers.common['X-User'] = user;
}

const config = {
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
};

const getters = {
    PLANPOSTUPLEN: state => {
        return state.planpostuplenilist;
    },
};
const mutations = {
    SET_PLANPOSTUPLEN: (state, payload) => {
        state.planpostuplenilist = payload;
    },

    REMOVE_PLANPOSTUPLEN: (state, payload) => {
        state.planpostuplenilist.data = state.planpostuplenilist.data.filter(function(item) {
            return item.ID !== payload.id
        })
    },
};
const actions = {
    GET_PLANPOSTUPLEN: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.get('/budget-api/planpost/list?' + req).catch(err => {
            return err;
        });
        context.commit('SET_PLANPOSTUPLEN', data);
        return data;
    },

    SAVE_PLANPOSTUPLEN: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.post('/budget-api/planpost/add', req, config);
        return data;
    },

    EDIT_PLANPOSTUPLEN: async (context, payload) => {
        let {data} = await axios.get('/budget-api/planpost/edit/' + payload.id);
        return data;
    },

    UPDATE_PLANPOSTUPLEN: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.post('/budget-api/planpost/update',req, config);
        return data;
    },

    UPDATESTATE_PLANPOSTUPLEN: async (context, payload) => {
        const req = querystring.stringify(payload);
        let {data} = await axios.post('/budget-api/planpost/updatestate', req, config);
        return data;
    },

    DEL_PLANPOSTUPLEN: async (context, payload) => {
        const req = querystring.stringify({id: payload.id});
        await axios.post('/budget-api/planpost/del', req, config);
        context.commit('REMOVE_PLANPOSTUPLEN', payload);
    },
};


export default {
    state: () => ({
        planpostuplenilist: null,
    }),
    mutations,
    actions,
    getters
};
